import { ReactElement } from 'react'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'

import Meta from '@/components/base/Meta'
import PageBuilder from '@/components/layout/Builder'
import Layout from '@/components/layout/Layout'
import usePagePrecache from '@/hooks/usePagePrecache'
import { getPagePrecacheMedia } from '@/utils/page'

import { WPPageData } from '@/types'

export default function Home(
  pageData: InferGetStaticPropsType<typeof getStaticProps>
) {
  usePagePrecache(true, getPagePrecacheMedia(pageData))

  return <PageBuilder pageData={pageData} />
}

Home.getLayout = function getLayout(page: ReactElement, pageData: WPPageData) {
  return (
    <Layout pageData={pageData}>
      <Meta pageData={pageData} />
      {page}
    </Layout>
  )
}

export async function getStaticProps(
  // eslint-disable-next-line no-unused-vars
  props: GetStaticPropsContext<{ routes: string[] }>
) {
  const pageData = require(`@/data/pages/lifestyle.json`)

  return {
    props: {
      ...pageData
    }
  }
}
